/**
 * Hàm replace string chứa các ký tự html
 * @param str String
 * @returns new string before replace
 */
export default (str: string): string => {
  if (!str) {
    return str;
  }
  const entityMap: any = {
    '<!--{{sec_divider}}-->': '</{{sec_divider}}>', // Hotfix for section divider of (P) Description
  };
  Object.keys(entityMap).forEach((key) => {
    str = str.replaceAll(key, entityMap[key]);
  });
  return str;
};
